import React from 'react'

import { Body3, Heading4, Join, Space, Strong } from '@gousto-internal/citrus-react'
import { useSelector } from 'react-redux'

import { MenuRecipeIngredient } from '@library/menu-service/queries/menuApiMenuRecipe/types'

import { getNumPortions } from 'selectors/basket'

import { Ingredient } from './Ingredient'

import css from './Ingredients.css'

type IngredientsProps = {
  ingredients: MenuRecipeIngredient[]
  loading: boolean
}

const Ingredients = ({ ingredients, loading }: IngredientsProps) => {
  const numPortion = useSelector(getNumPortions)
  const people = numPortion > 1 ? 'people' : 'person'

  return (
    <div>
      <div>
        <Join with={<Space size={4} />}>
          <Heading4>Ingredients</Heading4>
          <Body3>For allergens see the &apos;Ingredients contain&apos; section</Body3>
          <Body3>
            Ingredients shown are for{' '}
            <Strong>
              {numPortion} {people}
            </Strong>
            .
          </Body3>
        </Join>
      </div>
      <div className={css.ingredientsContainer}>
        {ingredients
          .filter((ingredient) => {
            if (loading) return true
            const quantity = ingredient.quantities?.in_meal ?? 0

            return quantity > 0
          })
          .map((ingredient) => (
            <div className={css.ingredient} key={ingredient && ingredient.id}>
              {ingredient && <Ingredient ingredient={ingredient} loading={loading} />}
            </div>
          ))}
      </div>
    </div>
  )
}

export { Ingredients }
